/**
 * Placeholder in the shape of a blog post: back link, meta line, title,
 * description and body. Used while the post chunk and its data load.
 */
export function PostSkeleton() {
  return (
    <article aria-busy="true">
      <p className="sr-only">Loading post…</p>
      <div aria-hidden="true">
        <header className="mb-10 sm:mb-12">
          <div className="skeleton mb-8 h-3 w-24 rounded-sm" />
          <div className="mb-4 flex h-3 items-center gap-2.5">
            <div className="skeleton h-2 w-20 rounded-sm" />
            <div className="skeleton h-2 w-14 rounded-sm" />
            <div className="skeleton h-2 w-10 rounded-sm" />
          </div>
          <div className="mb-4 space-y-2">
            <div className="skeleton h-7 w-full rounded-sm sm:h-8 lg:h-9" />
            <div className="skeleton h-7 w-3/4 rounded-sm sm:h-8 lg:h-9" />
          </div>
          <div className="space-y-2">
            <div className="skeleton h-3.5 w-full rounded-sm sm:h-4" />
            <div className="skeleton h-3.5 w-4/5 rounded-sm sm:h-4" />
          </div>
        </header>

        <div className="space-y-5">
          <div className="space-y-2">
            <div className="skeleton h-4 w-full rounded-sm" />
            <div className="skeleton h-4 w-full rounded-sm" />
            <div className="skeleton h-4 w-11/12 rounded-sm" />
          </div>
          <div className="space-y-2">
            <div className="skeleton h-4 w-full rounded-sm" />
            <div className="skeleton h-4 w-full rounded-sm" />
            <div className="skeleton h-4 w-3/4 rounded-sm" />
          </div>
          <div className="pt-3">
            <div className="skeleton h-5 w-2/5 rounded-sm" />
          </div>
          <div className="space-y-2">
            <div className="skeleton h-4 w-full rounded-sm" />
            <div className="skeleton h-4 w-full rounded-sm" />
            <div className="skeleton h-4 w-5/6 rounded-sm" />
          </div>
          <div className="skeleton h-28 w-full rounded" />
        </div>
      </div>
    </article>
  )
}
